import { createFileRoute } from "@tanstack/react-router";
import AdminBuyersGuide from "@/pages/admin/AdminBuyersGuide";

export const Route = createFileRoute("/_adminLayout/admin/buyers-guide")({
  component: AdminBuyersGuide,
});
